import { Monitor, Globe, HelpCircle, ExternalLink, Cpu, Shield, Wifi, Database } from "lucide-react";

const TECH_LINKS = [
  { name: "Microsoft Support", icon: Monitor, url: "https://support.microsoft.com", color: "bg-blue-600" },
  { name: "Google Help", icon: Globe, url: "https://support.google.com", color: "bg-red-500" },
  { name: "Chrome Help", icon: Globe, url: "https://support.google.com/chrome", color: "bg-yellow-600" },
  { name: "Apple Support", icon: Monitor, url: "https://support.apple.com", color: "bg-gray-700" },
  { name: "Windows Help", icon: Monitor, url: "https://support.microsoft.com/windows", color: "bg-blue-500" },
  { name: "Firefox Help", icon: Globe, url: "https://support.mozilla.org", color: "bg-orange-600" },
  { name: "Stack Overflow", icon: HelpCircle, url: "https://stackoverflow.com", color: "bg-orange-500" },
  { name: "Reddit Tech", icon: Cpu, url: "https://www.reddit.com/r/techsupport", color: "bg-orange-700" },
  { name: "Tom's Hardware", icon: Cpu, url: "https://www.tomshardware.com", color: "bg-red-600" },
  { name: "CNET", icon: Monitor, url: "https://www.cnet.com", color: "bg-red-700" },
  { name: "PC Mag", icon: Cpu, url: "https://www.pcmag.com", color: "bg-purple-600" },
  { name: "Virus Total", icon: Shield, url: "https://www.virustotal.com", color: "bg-green-600" },
  { name: "Speed Test", icon: Wifi, url: "https://www.speedtest.net", color: "bg-cyan-600" },
  { name: "Down Detector", icon: Database, url: "https://downdetector.com", color: "bg-pink-600" },
];

const TechTalkPanel = ({ roomId }) => {
  if (roomId !== "tech-talk") return null;

  const openLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="retro-window mb-2" data-testid="tech-talk-panel">
      <div className="retro-title-bar px-2 py-1">
        <span className="flex items-center gap-1">
          <Cpu className="w-4 h-4" />
          💻 TECH HELP
        </span>
      </div>

      <div className="p-2 bg-gradient-to-b from-gray-100 to-gray-200 max-h-[300px] overflow-y-auto retro-scrollbar">
        <div className="space-y-1">
          {TECH_LINKS.map((link, index) => {
            const Icon = link.icon;
            return (
              <button
                key={index}
                className={`${link.color} hover:opacity-90 text-white rounded w-full p-1.5 transition-all flex items-center gap-2 text-xs`}
                onClick={() => openLink(link.url)}
              >
                <Icon className="w-4 h-4 flex-shrink-0" />
                <span className="font-bold truncate">{link.name}</span>
                <ExternalLink className="w-3 h-3 ml-auto flex-shrink-0 opacity-70" />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TechTalkPanel;
